export const setObjectInLocalStorage = (key, obj) => {
  if (typeof window !== 'undefined') {
    if (!key || !obj) {
      return;
    }
    const stringObj = JSON.stringify(obj);
    localStorage.setItem(key, stringObj);
  }
};

export const getObjectFromLocalStorage = (key) => {
  if (typeof window !== 'undefined') {
    if (!key) {
      return;
    }
    const stringObj = localStorage.getItem(key);
    if (!stringObj) {
      return;
    }
    try {
      const obj = JSON.parse(stringObj);
      return obj;
    } catch (e) {
      return;
    }
  }
};
